import { SkillsMarketplacePage } from "@/components/Skills/SkillsMarketplacePage";

export function SkillsMarketplace() {
  return <SkillsMarketplacePage />;
}
